interface BrandMarkProps {
  /** Second line under the wordmark. The latest screens use the active section
   *  (e.g. "Workspace", "Resources"); falls back to the product tagline. */
  subtitle?: string;
}

// CITS AMPS brand lockup (logo mark + wordmark).
export function BrandMark({ subtitle = "Clinical assessment" }: BrandMarkProps = {}) {
  return (
    <div className="flex min-w-0 items-center gap-3">
      <div
        aria-hidden="true"
        className="flex h-11 w-11 shrink-0 items-center justify-center rounded-[14px] bg-[color:var(--bg-primary)] border border-[color:var(--border-primary)]"
      >
        <img src="/cits-logo.svg" alt="" width={32} height={32} className="h-8 w-8" />
      </div>
      <div className="min-w-0 leading-tight">
        <div className="truncate text-sm font-semibold text-[color:var(--text-primary)]">
          CITS AMPS
        </div>
        <div className="truncate text-xs text-[color:var(--text-tertiary)]">{subtitle}</div>
      </div>
    </div>
  );
}
